export default __webpack_public_path__ + "static/media/hair-0-3.cc69ef29.svg";